
import { Component, Vue, Prop } from "vue-property-decorator";
@Component({
  components: {}
})
export default class EditIcon extends  Vue {
  @Prop({ type: Number, required: false, default: 17 }) readonly width!: number;
  @Prop({ type: Number, required: false, default: 17 }) readonly height!: number;
}
